"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STICKY_TABLE_ROW = exports.STICKY_TABLE_HEAD = exports.STICKY_TABLE_FOOTER = exports.STICKY_TABLE_CELL = exports.STICKY_TABLE_BODY = void 0;
var STICKY_TABLE_ROW = exports.STICKY_TABLE_ROW = 'sticky-table-row';
var STICKY_TABLE_CELL = exports.STICKY_TABLE_CELL = 'sticky-table-cell';
var STICKY_TABLE_HEAD = exports.STICKY_TABLE_HEAD = 'sticky-table-head';
var STICKY_TABLE_BODY = exports.STICKY_TABLE_BODY = 'sticky-table-body';
var STICKY_TABLE_FOOTER = exports.STICKY_TABLE_FOOTER = 'sticky-table-footer';